// removed by extract-text-webpack-plugin
module.exports = {"input":"_2XHdJSfyIrTMXlnzQFtYkM","hiddenDiv":"_3SPptYTczFcsrLybrNjV6O","tagsContainer":"_2WfNTVmCJU3OY6CgE0YMse","error":"_12ggCE6sUsvV5OtXwYJ8ne","disabled":"_2N-kEZpnqHfiu0Yc3LY_zv","hasFocus":"j8vM8mZ3vUEabaRCcj5ur"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/MultiSelect/InputWithTags.scss
// module id = ./node_modules/wix-style-react/dist/es/src/MultiSelect/InputWithTags.scss
// module chunks = 0